export default [{ "name": "Dashbord", "img": "icon1.png" ,"link":""},
{ "name": "基础数据", "img": "icon1.png","link":"/basedata/areabuilding" },
  { "name": "工程申请", "img": "icon1.png","link":"/engineeringapplication/invoicesappliction" },
  { "name": "单据签核", "img": "icon1.png","link":"/invoicessigned/unitsignedconfig/unitsigned" },
  { "name": "预约厂商&概算", "img": "icon3..png","link":"/approximateamount/appointmanufacturerconfig/appointmanufacturer" },
  { "name": "厂商工程标单", "img": "icon1.png","link":"/manufacturerbid/manufacturerbidconfig/makemanufacturerbid" },
  { "name": "询价", "img": "icon1..png","link":"/inquiry/factoryinquiryconfig/factoryinquiry" },
  { "name": "报表", "img": "icon1.png","link":"" }]
